import { gql } from 'apollo-boost';

export const LIST_PARTICIPANT_RAISING = gql`
  query listNotValidatedParticipantRaising {
    listNotValidatedParticipantRaising {
      edges {
        node {
          id
          hasSignedSd
          numFee
          amount
          createdDate
          updatedDate
          validated
          classFund {
            id
            name
          }
          lastParticipation {
            id
            order
            state
            participationPercentage
            coParticipants {
              edges {
                node {
                  participationPercentage
                  client {
                    id
                    user {
                      id
                      firstName
                      lastName
                      maternalSurname
                      documentNumber
                      isVinculated
                    }
                    linkedpeopleclientrelationSet {
                      edges {
                        node {
                          id
                          active
                          relation
                          linkedType
                          linkedPeople {
                            id
                            active
                            firstName
                            lastName
                            maternalSurname
                            linkedType
                            position
                            company
                            relation
                            documentType {
                              id
                              name
                            }
                            documentNumber
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          raising {
            id
            number
            acronym
            fund {
              id
              businessName
              currency {
                symbol
              }
            }
          }
          linkedPeople {
            edges {
              node {
                id
                active
                relation
                linkedType
                linkedPeople {
                  id
                  active
                  firstName
                  lastName
                  maternalSurname
                  position
                  company
                  documentType {
                    id
                    name
                  }
                  documentNumber
                }
              }
            }
          }
          client {
            id
            user {
              firstName
              lastName
              maternalSurname
              documentNumber
              isVinculated
            }
          }
        }
      }
    }
  }
`;

export const LIST_PARTICIPANT_RAISING_REJECTED = gql`
  query listRejectedParticipantRaising {
    listRejectedParticipantRaising {
      edges {
        node {
          id
          numFee
          amount
          createdDate
          updatedDate
          validated
          classFund {
            id
            name
          }
          lastParticipation {
            id
            order
            state
            participationPercentage
            coParticipants {
              edges {
                node {
                  participationPercentage
                  client {
                    id
                    user {
                      id
                      firstName
                      lastName
                      maternalSurname
                      documentNumber
                      isVinculated
                    }
                    linkedpeopleclientrelationSet {
                      edges {
                        node {
                          id
                          active
                          relation
                          linkedType
                          linkedPeople {
                            id
                            active
                            firstName
                            lastName
                            maternalSurname
                            linkedType
                            position
                            company
                            relation
                            documentType {
                              id
                              name
                            }
                            documentNumber
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          raising {
            id
            number
            acronym
            fund {
              id
              businessName
              currency {
                symbol
              }
            }
          }
          linkedPeople {
            edges {
              node {
                id
                active
                relation
                linkedType
                linkedPeople {
                  id
                  active
                  firstName
                  lastName
                  maternalSurname
                  position
                  company
                  documentType {
                    id
                    name
                  }
                  documentNumber
                }
              }
            }
          }
          client {
            id
            user {
              firstName
              lastName
              maternalSurname
              documentNumber
              isVinculated
            }
          }
        }
      }
    }
  }
`;

export const LIST_PARTICIPANT_RAISING_VALIDATED = gql`
  query listValidatedParticipantRaising(
    $search: String
    $first: Int
    $last: Int
    $beforeCursor: String
    $afterCursor: String
  ) {
    listValidatedParticipantRaising(
      search: $search
      first: $first
      last: $last
      before: $beforeCursor
      after: $afterCursor
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          hasSignedSd
          numFee
          amount
          createdDate
          updatedDate
          dateApproved
          validated
          classFund {
            id
            name
          }
          lastParticipation {
            id
            order
            state
            participationPercentage
            coParticipants {
              edges {
                node {
                  participationPercentage
                  client {
                    id
                    user {
                      id
                      firstName
                      lastName
                      maternalSurname
                      documentNumber
                      isVinculated
                    }
                    linkedpeopleclientrelationSet {
                      edges {
                        node {
                          id
                          active
                          relation
                          linkedType
                          linkedPeople {
                            id
                            active
                            firstName
                            lastName
                            maternalSurname
                            linkedType
                            position
                            company
                            relation
                            documentType {
                              id
                              name
                            }
                            documentNumber
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          raising {
            id
            number
            acronym
            fund {
              id
              businessName
              currency {
                symbol
              }
            }
          }
          linkedPeople {
            edges {
              node {
                id
                active
                relation
                linkedType
                linkedPeople {
                  id
                  active
                  firstName
                  lastName
                  maternalSurname
                  position
                  company
                  documentType {
                    id
                    name
                  }
                  documentNumber
                }
              }
            }
          }
          client {
            id
            user {
              firstName
              lastName
              maternalSurname
              documentNumber
              isVinculated
            }
          }
        }
      }
    }
  }
`;

export const GET_REPORT_EXCEL = gql`
  {
    vinculatedExcel {
      success
      file
    }
  }
`;

export const APPROVE_VINCULATED_PARTICIPANT = gql`
  mutation approveVinculatedParticipant($orderId: ID!) {
    approveVinculatedParticipant(orderId: $orderId) {
      approved
    }
  }
`;

export const DISAPPROVE_VINCULATED_PARTICIPANT = gql`
  mutation disapproveVinculatedParticipant($orderId: ID!) {
    disapproveVinculatedParticipant(orderId: $orderId) {
      disapproved
    }
  }
`;

export const LIST_RELATIVES = gql`
  query listRelatives {
    listRelatives {
      edges {
        node {
          documentNumber
          typeRelation
          clientSet {
            edges {
              node {
                user {
                  firstName
                  lastName
                  maternalSurname
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const FILE_DOWNLOAD = gql`
  mutation fileDownloadSd($orderId: ID!) {
    fileDownloadSd(orderId: $orderId) {
      urls
      fileName
    }
  }
`;
